import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface ApparatusItemProps {
  index: number;
  name: string;
  instruction: string;
}

const ApparatusItem: React.FC<ApparatusItemProps> = ({ index, name, instruction }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-w-0 border rounded-md mb-2">
      <div className="flex min-w-0 justify-between items-center gap-3 px-4 py-3 cursor-pointer" onClick={() => setOpen(!open)}>
        <div className="flex min-w-0 items-start gap-3">
          <span className="shrink-0 font-medium text-gray-800">{index}.</span>
          <span className="min-w-0 font-medium text-gray-800 whitespace-normal break-words [overflow-wrap:anywhere]">{name}</span>
        </div>
        {open ? <ChevronUp className="shrink-0" size={18} /> : <ChevronDown className="shrink-0" size={18} />}
      </div>
      {open && (
        <>
          <div className="border-t border-gray-200" />
          <div className="min-w-0 px-4 pt-3 pb-3">
            <h4 className="font-semibold text-sm text-gray-500 mb-1.5">Works to be Carried Out</h4>
            <div
              className="min-w-0 max-w-full font-normal text-gray-800 whitespace-normal break-words [overflow-wrap:anywhere] [&_*]:max-w-full [&_img]:h-auto [&_ul]:list-disc [&_ul]:ml-6 [&_ol]:list-decimal [&_ol]:ml-6"
              dangerouslySetInnerHTML={{
                __html: instruction,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ApparatusItem;
